// Imports
var ___CSS_LOADER_API_IMPORT___ = require("./node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".block_rich-text_invert-colors .block__body a{color:#fff!important}h2,h3,h4,h5,h6{margin-bottom:0!important}@media only screen and (min-width:992px){.block_columns>.block__body>.block__section_main{gap:0!important}}.box_outline img{border:2px solid #147cbb}.homepage_blue h2{color:#147cbb;font-family:Oswald,sans-serif;font-size:48px;font-weight:700}#sticky-button a{border-radius:15px;padding:2em}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
